import { Warning } from '@phosphor-icons/react';
import { toast } from 'sonner';

import { Button } from '../ui/Button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../ui/Dialog';
import pt from '../../locales/pt';

function format(template, params) {
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    params[key] === undefined ? `{${key}}` : String(params[key]),
  );
}

/**
 * Confirmação de apagar selfie — substitui window.confirm nativo.
 * .pen: fqUFU/wpIzU (Selfie · Histórico · eliminar dialog) › ds/overlay/dialog--destructive (q4LhU)
 */
export function DeleteSelfieDialog({
  open,
  onOpenChange,
  monthYear,
  onConfirm,
  isPending = false,
}) {
  const handleConfirm = async () => {
    try {
      await onConfirm();
    } catch (err) {
      toast.error(typeof err === 'string' ? err : pt.snapshots.history.deleteError);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent tone="destructive" hideClose>
        <div className="flex flex-col gap-space-4">
          {/* .pen master (q4LhU) usa $danger-700 fixo — ilegível em dark contra
              $danger-tint (mesmo padrão de gap de contraste já visto noutros
              tint+700). text-danger-fg é o par temático correcto, como já
              usado para warning-tint noutros componentes desta sessão. */}
          <span className="flex size-11 shrink-0 items-center justify-center rounded-ds-full bg-danger-tint">
            <Warning className="size-[22px] text-danger-fg" weight="regular" aria-hidden />
          </span>
          <div className="flex flex-col gap-space-1">
            <DialogTitle className="font-display text-type-display-metric font-semibold text-card-foreground">
              {pt.snapshots.history.deleteConfirmTitle}
            </DialogTitle>
            <DialogDescription className="text-type-body leading-[1.45] text-muted-foreground">
              {format(pt.snapshots.history.deleteConfirmBody, { month: monthYear })}
            </DialogDescription>
          </div>
          <div className="flex justify-end gap-space-3">
            <Button
              variant="ghost"
              size="md"
              onClick={() => onOpenChange(false)}
              disabled={isPending}
            >
              {pt.common.cancel}
            </Button>
            <Button variant="destructive" size="md" onClick={handleConfirm} disabled={isPending}>
              {isPending ? pt.common.loading : pt.snapshots.history.deleteLabel}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
